// extracted by mini-css-extract-plugin
export default {"container":"Kl-z","blurb":"Ll-z","links":"Ml-z"};